/**
 * Arayan tarafta, karşı taraf cevap verene kadar duyulan yerel bekleme tonu.
 * WebRTC medya akışına bağlanmaz; seçili ahize/hoparlör çıkışında çalar.
 */

let audioContext = null;
let tekrarZamanlayici = null;
let aktifDugumler = [];
let caliyor = false;
let nesil = 0;

function contextAl() {
  if (typeof window === "undefined") return null;
  const AudioContextSinifi = window.AudioContext || window.webkitAudioContext;
  if (!AudioContextSinifi) return null;
  if (!audioContext || audioContext.state === "closed") {
    audioContext = new AudioContextSinifi();
  }
  return audioContext;
}

/** iOS/Safari ses iznini arama düğmesinin kullanıcı hareketi içinde hazırlar. */
export function hazirla() {
  try {
    const ctx = contextAl();
    if (!ctx) return false;
    ctx.resume?.().catch(() => {});

    // Bazı WebKit sürümleri yalnız resume() ile değil, kullanıcı hareketi
    // içinde başlatılan sessiz bir kaynakla açılır.
    const kaynak = ctx.createBufferSource();
    const kazanc = ctx.createGain();
    kazanc.gain.value = 0;
    kaynak.buffer = ctx.createBuffer(1, 1, ctx.sampleRate);
    kaynak.connect(kazanc);
    kazanc.connect(ctx.destination);
    kaynak.start(0);
    return true;
  } catch (_) {
    return false;
  }
}

function kisaTon(ctx, baslangic, sure = 0.38) {
  const kazanc = ctx.createGain();
  const simdi = Math.max(ctx.currentTime, baslangic);
  kazanc.gain.setValueAtTime(0.0001, simdi);
  kazanc.gain.exponentialRampToValueAtTime(0.075, simdi + 0.025);
  kazanc.gain.setValueAtTime(0.075, simdi + Math.max(0.04, sure - 0.035));
  kazanc.gain.exponentialRampToValueAtTime(0.0001, simdi + sure);
  kazanc.connect(ctx.destination);

  const osilatorler = [440, 480].map((frekans) => {
    const osilator = ctx.createOscillator();
    osilator.type = "sine";
    osilator.frequency.value = frekans;
    osilator.connect(kazanc);
    osilator.start(simdi);
    osilator.stop(simdi + sure + 0.02);
    return osilator;
  });

  aktifDugumler.push(kazanc, ...osilatorler);
}

function donguCal(buNesil) {
  if (!caliyor || buNesil !== nesil) return;
  const ctx = contextAl();
  if (!ctx) return;
  ctx.resume?.().catch(() => {});

  const baslangic = ctx.currentTime + 0.02;
  kisaTon(ctx, baslangic);
  kisaTon(ctx, baslangic + 0.55);
  tekrarZamanlayici = window.setTimeout(() => donguCal(buNesil), 2800);
}

function aktifDugumleriTemizle() {
  if (tekrarZamanlayici) {
    clearTimeout(tekrarZamanlayici);
    tekrarZamanlayici = null;
  }
  aktifDugumler.forEach((dugum) => {
    try { dugum.stop?.(); } catch (_) { /* zaten durmuş olabilir */ }
    try { dugum.disconnect?.(); } catch (_) { /* yoksay */ }
  });
  aktifDugumler = [];
}

export function baslat() {
  if (caliyor) return;
  const ctx = contextAl();
  if (!ctx) return;
  caliyor = true;
  nesil += 1;
  donguCal(nesil);
}

/**
 * Native ses yolu ahize ↔ hoparlör değiştiğinde bekleme tonunu yeni çıkışta
 * yeniden üretir. WebRTC oturumuna veya uzak ses akışına dokunmaz.
 */
export function cikisiTazele() {
  if (!caliyor) return false;
  const ctx = contextAl();
  if (!ctx) return false;

  nesil += 1;
  const buNesil = nesil;
  aktifDugumleriTemizle();

  const yenidenCal = () => {
    if (!caliyor || buNesil !== nesil) return;
    donguCal(buNesil);
  };
  try {
    const sonuc = ctx.resume?.();
    if (sonuc && typeof sonuc.then === "function") {
      sonuc.then(yenidenCal).catch(yenidenCal);
    } else {
      yenidenCal();
    }
  } catch (_) {
    yenidenCal();
  }
  return true;
}

export function durdur() {
  caliyor = false;
  nesil += 1;
  aktifDugumleriTemizle();
}

export default { hazirla, baslat, cikisiTazele, durdur };
